import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/PortugueseSpeakingNutritionist";
import { breadcrumbJsonLd, faqJsonLd, pageHead, SITE_URL } from "@/lib/seo";

const PATH = "/portuguese-speaking-nutritionist-brisbane";

const serviceJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Clara Camille - Portuguese-speaking nutritionist in Brisbane",
  description:
    "Nutrition coaching in Portuguese for Brazilians living in Australia. In-person appointments in Hamilton, Brisbane, and online consultations Australia-wide.",
  url: `${SITE_URL}${PATH}`,
  inLanguage: "en-AU",
  parentOrganization: { "@id": `${SITE_URL}/#business` },
  areaServed: [
    { "@type": "City", name: "Brisbane", containedInPlace: { "@type": "State", name: "Queensland" } },
    { "@type": "Country", name: "Australia" },
  ],
  availableLanguage: ["Portuguese"],
  telephone: "+61423038977",
};

export const Route = createFileRoute("/portuguese-speaking-nutritionist-brisbane")({
  head: () =>
    pageHead({
      title: "Portuguese-speaking Nutritionist in Brisbane | Clara Camille",
      description:
        "Brazilian nutritionist in Hamilton, Brisbane, offering nutrition coaching in Portuguese for Brazilians living in Australia. In person or online, Australia-wide. Free first consultation.",
      path: PATH,
      ogDescription:
        "Nutrition coaching in Portuguese for Brazilians in Australia. In person in Brisbane or online. Free first consultation.",
      jsonLd: [
        serviceJsonLd,
        faqJsonLd(faqItems),
        breadcrumbJsonLd([{ name: "Portuguese-speaking nutritionist in Brisbane", path: PATH }]),
      ],
    }),
  component: Page,
});
